import {FakturierungsbelegEntitiesState} from '../states/fakturierungsbeleg-entities.state';
import {fakturierungsbelegEntitiesAdapter} from '../adapters/fakturierungsbeleg-entities.adapter';
import {createReducer, on} from '@ngrx/store';
import {FakturierungsbelegEntitiesActions} from '../actions/fakturierungsbeleg-entities.actions';
import {BelegDTO} from '../../openapi/fakturierung-openapi';


export const initialFakturierungsbelegEntitiesState: FakturierungsbelegEntitiesState = fakturierungsbelegEntitiesAdapter.getInitialState({
  isLoading: false,
  totalElements: 0,
  createSaveActionSuccessful: false,
  deleteActionSuccessful: false,
  createIsLoading: false,
  finalizeIsLoading: false,
  duplicateIsLoading: false,
});

export const fakturierungsbelegEntitiesReducer = createReducer(
  initialFakturierungsbelegEntitiesState,

  on(FakturierungsbelegEntitiesActions.readFakturierungsbelegeSuccess, (state, {belegDtos}) => {
    return fakturierungsbelegEntitiesAdapter.setAll(belegDtos, {
      ...state,
      isLoading: false,
      totalElements: belegDtos.length,
    });
  }),

  // on(FakturierungsbelegEntitiesActions.updateFakturierungsbelegEinstellungen, (state, {
  //   belegId,
  //   betriebId,
  // }) => {
  //   return fakturierungsbelegEntitiesAdapter.updateOne(
  //     {
  //       id: belegDto.id,
  //       changes: {
  //         einstellung: {
  //           ...belegDto.einstellung,
  //           id: einstellungId,
  //           revision: einstellungRevision,
  //         },
  //       }
  //     },
  //     state
  //   );
  // }),

  on(FakturierungsbelegEntitiesActions.readFakturierungsbelegeFailure, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(FakturierungsbelegEntitiesActions.countFakturierungsbelegeElementsSuccess, (state, {totalElements}) => ({
    ...state,
    totalElements,
  })),

  on(FakturierungsbelegEntitiesActions.getFakturierungsbelegByIdSuccess, (state, {belegDto}) => {
    return fakturierungsbelegEntitiesAdapter.upsertOne(belegDto, state);
  }),

  on(FakturierungsbelegEntitiesActions.getFakturierungsbelegByIdFailure, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(FakturierungsbelegEntitiesActions.createFakturierungsbeleg, (state) => ({
    ...state,
    createSaveActionSuccessful: false,
    createIsLoading: true,
  })),

  on(FakturierungsbelegEntitiesActions.createFakturierungsbelegSuccess, (state, {belegDto}) => {
    return fakturierungsbelegEntitiesAdapter.addOne(belegDto, {
      ...state,
      totalElements: state.totalElements + 1,
      createSaveActionSuccessful: true,
      createIsLoading: false,
    });
  }),

  on(FakturierungsbelegEntitiesActions.createFakturierungsbelegFailure, (state) => ({
    ...state,
    createSaveActionSuccessful: false,
    createIsLoading: false,
  })),

  on(FakturierungsbelegEntitiesActions.updateFakturierungsbelegSuccess, (state, {belegDto}) => {
    return fakturierungsbelegEntitiesAdapter.updateOne({id: belegDto.id, changes: belegDto}, state);
  }),

  on(FakturierungsbelegEntitiesActions.updateFakturierungsbelegFailure, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(FakturierungsbelegEntitiesActions.deleteFakturierungsbeleg, (state) => ({
    ...state,
    deleteActionSuccessful: false,
  })),

  on(FakturierungsbelegEntitiesActions.deleteFakturierungsbelegSuccess, (state, {belegId}) => {
    return fakturierungsbelegEntitiesAdapter.removeOne(belegId, {
      ...zielEntfernen(state, belegId),
      totalElements: state.totalElements - 1,
      deleteActionSuccessful: true,
    });
  }),

  on(FakturierungsbelegEntitiesActions.deleteFakturierungsbelegFailure, (state) => ({
    ...state,
    deleteActionSuccessful: false,
  })),

  on(FakturierungsbelegEntitiesActions.finalizeFakturierungsbeleg, (state) => {
    return {
      ...state,
      finalizeIsLoading: true,
    };
  }),

  on(FakturierungsbelegEntitiesActions.finalizeFakturierungsbelegSuccess, (state, {belegDto}) => {
    return fakturierungsbelegEntitiesAdapter.upsertOne(belegDto, {
      ...state,
      finalizeIsLoading: false,
    });
  }),

  on(FakturierungsbelegEntitiesActions.finalizeFakturierungsbelegFailure, (state) => {
    return {
      ...state,
      finalizeIsLoading: false,
    };
  }),

  on(FakturierungsbelegEntitiesActions.cancelFakturierungsbelegSuccess, (state, {cancelledBeleg, correctedBeleg}) => {
    // INFO: immediate update of UI. No need for extra http call to fetch the new list of Belege.
    // Beide betroffenen Belege kommen vollstaendig aus der Storno-Response.
    const updatedState = fakturierungsbelegEntitiesAdapter.upsertOne(
      cancelledBeleg,
      cancelledBeleg.status.storniert ? zielEntfernen(state, cancelledBeleg.id) : state,
    );

    // INFO: beim reinen Statuswechsel (z.B. Lieferschein) entsteht kein Korrekturbeleg.
    if (!correctedBeleg) {
      return updatedState;
    }

    return fakturierungsbelegEntitiesAdapter.upsertOne(correctedBeleg, {
      ...updatedState,
      totalElements: state.totalElements + 1,
    });
  }),

  on(FakturierungsbelegEntitiesActions.duplicateFakturierungsbeleg, (state) => ({
    ...state,
    duplicateIsLoading: true,
  })),

  on(FakturierungsbelegEntitiesActions.duplicateFakturierungsbelegSuccess, (state, {belegDto}) => {
    return fakturierungsbelegEntitiesAdapter.addOne(belegDto, {
      ...state,
      totalElements: state.totalElements + 1,
      duplicateIsLoading: false,
    });
  }),

  on(FakturierungsbelegEntitiesActions.duplicateFakturierungsbelegFailure, (state) => ({
    ...state,
    duplicateIsLoading: false,
  })),

  on(FakturierungsbelegEntitiesActions.konvertiereBelegSuccess, (state, {zielDto, quellDto}) => {
    const withZiel = fakturierungsbelegEntitiesAdapter.addOne(zielDto, {
      ...state,
      totalElements: state.totalElements + 1,
    });

    if (quellDto) {
      return fakturierungsbelegEntitiesAdapter.updateOne(
        {id: quellDto.id, changes: quellDto},
        withZiel,
      );
    }

    // INFO: Status-Refresh des Quellbelegs ist fehlgeschlagen (die Konvertierung selbst
    //       war erfolgreich) — Status lokal patchen, damit die Liste nicht veraltet anzeigt.
    const quelle = zielDto.quelle && state.entities[zielDto.quelle.belegId];
    if (!quelle) {
      return withZiel;
    }
    return fakturierungsbelegEntitiesAdapter.updateOne({
      id: quelle.id,
      changes: {
        ziel: {belegId: zielDto.id, belegart: zielDto.belegart, nummer: zielDto.nummer},
      },
    }, withZiel);
  }),

  on(FakturierungsbelegEntitiesActions.validateFakturierungsbelegFailure, (state, {belegId, error}) => {
    return fakturierungsbelegEntitiesAdapter.updateOne({
      id: belegId,
      changes: {
        problem: error.error,
      }},
      state);
  }),

  on(FakturierungsbelegEntitiesActions.validateFakturierungsbelegSuccess, (state, {belegId}) => {
    return fakturierungsbelegEntitiesAdapter.updateOne({
      id: belegId,
      changes: {
        problem: false,
      }},
      state);
  }),

);


// INFO: Ein geloeschter oder stornierter Zielbeleg gibt seine Quelle wieder frei.
function zielEntfernen(state: FakturierungsbelegEntitiesState, zielBelegId: string): FakturierungsbelegEntitiesState {
  const updates = Object.values(state.entities)
    .filter((beleg): beleg is BelegDTO => beleg?.ziel?.belegId === zielBelegId)
    .map(beleg => ({id: beleg.id, changes: {ziel: undefined}}));
  return fakturierungsbelegEntitiesAdapter.updateMany(updates, state);
}
